import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'

import LeaseName from '../rate-implicit-tool/LeaseName'
import DateSelection from '../rate-implicit-tool/DateSelection'
import FairValue from '../rate-implicit-tool/FairValue'
import PaymentBuilder from '../rate-implicit-tool/PaymentBuilder'
import ResidualValue from '../rate-implicit-tool/ResidualValue'

import './RitForm.css'
import useJurisdiction from '../../utils/Jurisdiction'

export default function RitForm({
	progress,
	content,
	definition,
	value,
	subValue,
	submitAnswer,
	navigation,
}) {
	const history = useHistory()
	const [errorMessage, setErrorMessage] = useState('')
	const { inputForm, setJurisdiction } = useJurisdiction()

	async function navigateForward(inputValue, subInputValue = 0) {
		const isQuestionAnswered = inputValue ? true : false
		let jurisdiction

		if (inputForm.initialJurisdiction === 'IFRS 16') {
			jurisdiction = 'IFRS 16'
			setJurisdiction(jurisdiction)
		} else if (inputForm.initialJurisdiction === 'GASB') {
			jurisdiction = inputForm.gasbJurisdiction
			setJurisdiction(jurisdiction)
		} else if (inputForm.initialJurisdiction === 'US GAAP') {
			jurisdiction = inputForm.gaapJurisdiction
			setJurisdiction(jurisdiction)
		}

		if (progress === 1) {
			if (isQuestionAnswered && jurisdiction) {
				setErrorMessage('')

				submitAnswer(progress, inputValue, jurisdiction)

				history.push(navigation.navYes)
				sessionStorage.setItem('formActive', '1')
			} else if (!isQuestionAnswered) {
				setErrorMessage(`${content} is required.`)
			} else if (!jurisdiction) {
				setErrorMessage(`Jurisdiction is required.`)
			}
		} else if (isQuestionAnswered) {
			setErrorMessage('')

			submitAnswer(progress, inputValue, subInputValue)

			history.push(navigation.navYes)
			sessionStorage.setItem('formActive', '1')
		} else {
			setErrorMessage(`${content} is required.`)
		}
	}

	function navigateBack() {
		sessionStorage.setItem('formActive', '1')
		history.goBack()
	}
	switch (progress) {
		case 1:
			return (
				<LeaseName
					navigateForward={navigateForward}
					content={content}
					errorMessage={errorMessage}
					value={value}
				/>
			)
		case 2:
			return (
				<DateSelection
					navigateForward={navigateForward}
					navigateBack={navigateBack}
					errorMessage={errorMessage}
					setErrorMessage={setErrorMessage}
					value={value}
					subValue={subValue}
				/>
			)
		case 3:
			return (
				<FairValue
					navigateForward={navigateForward}
					navigateBack={navigateBack}
					content={content}
					errorMessage={errorMessage}
					value={value}
				/>
			)
		case 4:
			return (
				<PaymentBuilder
					navigateForward={navigateForward}
					navigateBack={navigateBack}
					definition={definition}
					value={value}
				/>
			)
		case 5:
			return (
				<ResidualValue
					navigateForward={navigateForward}
					navigateBack={navigateBack}
					content={content}
					errorMessage={errorMessage}
					value={value}
				/>
			)
		default:
			break
	}
}
